import type React from 'react';
import { ReactNotifications, Store } from 'react-notifications-component';
import 'react-notifications-component/dist/theme.css';
import { styled } from 'styled-components';

const Container = styled.div`
  width: 100%;

  & .react-notification-root {
    .rnc__notification-container--bottom-center,
    .rnc__notification-container--bottom-left,
    .rnc__notification-container--bottom-right,
    .rnc__notification-container--mobile-bottom,
    .rnc__notification-container--mobile-top,
    .rnc__notification-container--top-center,
    .rnc__notification-container--top-left,
    .rnc__notification-container--top-right {
      position: fixed;
      z-index: 8000;
    }

    .rnc__notification-container--top-center {
      transform: translateX(-50%);
      top: 20px;
      left: 50%;
    }

    .rnc__notification-container--bottom-center {
      transform: translateX(-50%);
      bottom: 20px;
      left: 50%;
    }

    .rnc__notification-container--top-left {
      left: 20px;
      top: 20px;
    }

    .rnc__notification-container--top-right {
      right: 20px;
      top: 20px;
    }

    .rnc__notification-container--bottom-left {
      left: 20px;
      bottom: 20px;
    }

    .rnc__notification-container--bottom-right {
      bottom: 20px;
      right: 20px;
    }

    .rnc__notification-container--mobile-top {
      right: 20px;
      left: 20px;
      top: 20px;
    }

    .rnc__notification-container--mobile-bottom {
      right: 20px;
      left: 20px;
      bottom: 20px;
      margin-bottom: -15px;
    }

    .rnc__notification--default,
    .rnc__notification--default .rnc__notification-timer {
      background-color: ${({ theme }) => theme.colors.link100};
    }

    .rnc__notification--default .rnc__notification-timer-filler {
      background-color: ${({ theme }) => theme.colors.grey00_1};
    }

    .rnc__notification--default .rnc__rnc__notification-close-mark {
      background-color: ${({ theme }) => theme.colors.link100};
    }

    .rnc__notification--success {
      border-left: 8px solid ${({ theme }) => theme.colors.positive120};
    }

    .rnc__notification--success,
    .notification-success .rnc__notification-timer {
      background-color: ${({ theme }) => theme.colors.positive100};
    }

    .rnc__notification--success .rnc__notification-timer-filler {
      background-color: ${({ theme }) => theme.colors.grey00_1};
    }

    .rnc__notification--success .rnc__notification-close-mark {
      background-color: ${({ theme }) => theme.colors.positive100};
    }

    .rnc__notification--danger {
      border-left: 8px solid ${({ theme }) => theme.colors.critical120};
    }

    .rnc__notification--danger,
    .rnc__notification--danger .rnc__notification-timer {
      background-color: ${({ theme }) => theme.colors.critical100};
    }

    .rnc__notification--danger .rnc__notification-timer-filler {
      background-color: ${({ theme }) => theme.colors.grey00_1};
    }

    .rnc__notification--danger .rnc__notification-close-mark {
      background-color: ${({ theme }) => theme.colors.critical100};
    }

    .rnc__notification--info {
      border-left: 8px solid #138b9e;
    }

    .rnc__notification--info,
    .rnc__notification--info .rnc__notification-timer {
      background-color: #17a2b8;
    }

    .rnc__notification--info .rnc__notification-timer-filler {
      background-color: ${({ theme }) => theme.colors.grey00_1};
    }

    .rnc__notification--info .rnc__notification--close {
      background-color: #17a2b8;
    }

    .rnc__notification-warning {
      border-left: 8px solid #ce9c09;
    }

    .rnc__notification-warning,
    .rnc__notification-warning .rnc__notification-timer {
      background-color: #eab000;
    }

    .rnc__notification-warning .rnc__notification-timer-filler {
      background-color: ${({ theme }) => theme.colors.grey00_1};
    }

    .rnc__notification-warning .rnc__rnc__notification-close-mark {
      background-color: #eab000;
    }

    @keyframes timer {
      0% {
        width: 100%;
      }

      100% {
        width: 0;
      }
    }

    .rnc__notification-item {
      display: flex;
      position: relative;
      border-radius: 3px;
      margin-bottom: 15px;
      box-shadow: 1px 3px 4px rgb(0 0 0 / 20%);
      cursor: pointer;
    }

    .rnc__notification-item .rnc__notification-timer {
      width: 100%;
      margin-top: 10px;
    }

    .rnc__notification-item .rnc__notification-timer,
    .rnc__notification-item .rnc__notification-timer .rnc__notification-timer-filler {
      height: 3px;
      border-radius: 5px;
    }

    .rnc__notification-item .rnc__notification-title {
      color: ${({ theme }) => theme.colors.grey00_1};
      font-weight: 500;
      font-size: 14px;
      margin-top: 5px;
      margin-bottom: 5px;
    }

    .rnc__notification-item .rnc__notification-message {
      color: ${({ theme }) => theme.colors.grey00_1};
      max-width: calc(100% - 15px);
      font-size: 14px;
      line-height: 150%;
      word-wrap: break-word;
      margin-bottom: 0;
      margin-top: 0;
    }

    .rnc__notification-item .rnc__notification-content {
      padding: 8px 15px;
      display: inline-block;
      width: 100%;
      min-width: 270px;
    }

    .rnc__notification-item .rnc__notification-close-mark {
      width: 18px;
      height: 18px;
      border-radius: 50%;
      display: inline-block;
      position: absolute;
      right: 10px;
      top: 10px;
    }

    .rnc__notification-item .rnc__notification-close-mark::after {
      content: '\\D7';
      position: absolute;
      transform: translate(-50%, -50%);
      color: ${({ theme }) => theme.colors.grey00_1};
      font-size: 12px;
      left: 50%;
      top: 50%;
    }

    .rnc__notification-container-mobile-bottom .rnc__notification-item,
    .rnc__notification-container-mobile-top .rnc__notification-item {
      max-width: 100%;
      width: 100%;
    }
  }
`;

export type Containers = 'top-left' | 'top-right' | 'top-center' | 'bottom-left' | 'bottom-right' | 'bottom-center';

export interface Dismiss {
  duration: number;
  onScreen?: boolean;
}

export interface NotificationProps {
  container: Containers;
  animationIn: [string, string];
  animationOut: [string, string];
  dismiss: Dismiss;
}

const notification: NotificationProps = {
  container: 'top-right',
  animationIn: ['animated', 'fadeIn'],
  animationOut: ['animated', 'fadeOut'],
  dismiss: {
    duration: 5000,
    onScreen: true,
  },
};

/**
 * This component should render on top level of the app in single instance.
 * Because we have the global notify object below.
 * We can miss some notifications if we recreate this component because store will be recreated too.
 */
export const Notification: React.FC = () => (
  <Container className='notifications'>
    <ReactNotifications />
  </Container>
);

type Log = (title: string | React.ReactNode, message: string | React.ReactNode, override?: Partial<NotificationProps>) => void;

type Notify = {
  success: Log;
  danger: Log;
  info: Log;
  default: Log;
  warning: Log;
};

const notify: Notify = {
  success: (title, message, override = {}) => {
    Store.addNotification({
      ...notification,
      title,
      message,
      type: 'success',
      ...override,
    });
  },
  danger: (title, message, override = {}) => {
    Store.addNotification({
      ...notification,
      title,
      message,
      type: 'danger',
      ...override,
    });
  },
  info: (title, message, override = {}) => {
    Store.addNotification({
      ...notification,
      title,
      message,
      type: 'info',
      ...override,
    });
  },
  default: (title, message, override = {}) => {
    Store.addNotification({
      ...notification,
      title,
      message,
      type: 'default',
      ...override,
    });
  },
  warning: (title, message, override = {}) => {
    Store.addNotification({
      ...notification,
      title,
      message,
      type: 'warning',
      ...override,
    });
  },
};

export default notify;
